module.exports = __webpack_public_path__ + "static/img/alberto.4b9ea51e.jpg";